import ActionHelper from '@module/redux-actions';

export const actions = ActionHelper.types([
  'SHOW_UI',
  'HIDE_UI',
  'SET_WALLPAPER_UI_STYLE',
  'SET_PANEL_SIZE_HALF',
  'SET_PANEL_SIZE_FULL',
  'SET_PANEL_SIZE_NONE',
  'RESET_WALLPAPER_UI_STYLE',
]);

export default ActionHelper.generate({
  showUI: [actions.SHOW_UI],
  hideUI: [actions.HIDE_UI],
  setWallpaperUIStyle: [actions.SET_WALLPAPER_UI_STYLE, 'styles'],
  setPanelSizeHalf: [actions.SET_PANEL_SIZE_HALF],
  setPanelSizeFull: [actions.SET_PANEL_SIZE_FULL],
  setPanelSizeNone: [actions.SET_PANEL_SIZE_NONE],
  resetWallpaperUIStyle: [actions.RESET_WALLPAPER_UI_STYLE],
});
